





































































































































































































import {Vue, Component, Prop} from 'vue-property-decorator'
import {OrbitLeaderboardSummary} from '@/model/resource/OrbitLeaderboardSummary'

@Component
export default class OrbitLeaderboardCards extends Vue {
  @Prop({type: Object, required: true}) summary!: OrbitLeaderboardSummary

  currentPage = 0
  itemsPerView = 2
  totalItems = 4

  get totalPages() {
    return Math.max(1, Math.ceil(this.totalItems / this.itemsPerView))
  }

  formatGasRewards(amount: number) {
    if (!amount) return '0 GAS'

    const formatted = Number.isInteger(amount)
      ? String(amount)
      : amount.toFixed(3).replace(/\.?0+$/, '')

    return `${formatted} GAS`
  }

  goToPage(pageIndex: number) {
    this.currentPage = pageIndex
    const track = this.$refs.track as HTMLElement | undefined
    if (!track) return

    const itemWidth = track.scrollWidth / this.totalItems
    track.scrollTo({
      left: itemWidth * pageIndex * this.itemsPerView,
      behavior: 'smooth',
    })
  }
}
